import { getServiceURL } from "@/utils/url";

export const externalLogin = (type: string) => {
  // reevaluate loggedIn status after attempted external login
  sessionStorage.removeItem("loggedIn");
  window.location.assign(`${getServiceURL()}/auth/${type}/`);
};

export const toggleExternalRegister = (type: string): void => {
  // reevaluate loggedIn status after attempted external login
  sessionStorage.removeItem("loggedIn");
  window.location.assign(`${getServiceURL()}/auth/${type}/`);
};
